module.exports = __webpack_public_path__ + "static/media/W6.6bc71b05.jpg";